const SYNC_LOG_STORAGE_KEY = "beesql_sync_log_enabled";

const nowIso = () => new Date().toISOString();

const isEnabled = () => {
  if (typeof window === "undefined") return false;
  return (
    window.__BEESQL_SYNC_LOG_ENABLED__ === true ||
    window.localStorage?.getItem(SYNC_LOG_STORAGE_KEY) === "true"
  );
};

const installConsoleHelpers = () => {
  if (typeof window === "undefined") return;
  if (!window.__BEESQL_SYNC_LOGS__) window.__BEESQL_SYNC_LOGS__ = [];

  if (!window.enableBeeSyncLog) {
    window.enableBeeSyncLog = () => {
      window.__BEESQL_SYNC_LOG_ENABLED__ = true;
      window.localStorage?.setItem(SYNC_LOG_STORAGE_KEY, "true");
      console.log("BEE Sync Log enabled");
    };
  }

  if (!window.disableBeeSyncLog) {
    window.disableBeeSyncLog = () => {
      window.__BEESQL_SYNC_LOG_ENABLED__ = false;
      window.localStorage?.removeItem(SYNC_LOG_STORAGE_KEY);
      console.log("BEE Sync Log disabled");
    };
  }

  if (!window.dumpBeeSyncLog) {
    window.dumpBeeSyncLog = (syncId) => {
      const logs = window.__BEESQL_SYNC_LOGS__ || [];
      const selectedSyncId = syncId || logs[logs.length - 1]?.syncId;
      const rows = selectedSyncId ? logs.filter((row) => row.syncId === selectedSyncId) : logs;
      console.table(rows.map(({ timestamp, event, data }) => ({ timestamp, event, ...data })));
      console.log("BEE_SYNC_LOG_JSON", JSON.stringify(rows, null, 2));
      return rows;
    };
  }
};

const getStore = () => {
  installConsoleHelpers();
  if (typeof window === "undefined") return null;
  return window.__BEESQL_SYNC_LOGS__;
};

installConsoleHelpers();

export const createSyncLogId = (type, companyId) =>
  `${type || "UNKNOWN"}-${companyId || "no-company"}-${Date.now()}`;

export const countRows = (value) => {
  if (Array.isArray(value)) return value.length;
  if (value && typeof value === "object") return Object.keys(value).length;
  return 0;
};

export const summarizeDatabaseState = (state) => ({
  companyType: state?.database?.currentCompany?.type,
  companyId: state?.database?.currentCompany?.id,
  table: state?.ui?.table,
  areaId: state?.database?.currentShop?.area_id,
  shopId: state?.database?.currentShop?.shop_id,
  loadingTables: state?.database?.loadingTables,
  counts: {
    payments: countRows(state?.database?.currentShop?.payments),
    categories: countRows(state?.database?.currentShop?.categories),
    other: countRows(state?.database?.currentShop?.other),
    taxes: countRows(state?.database?.currentShop?.taxes),
    imports: countRows(state?.database?.currentShop?.imports),
  },
});

export const superSyncLog = (syncId, event, data = {}) => {
  if (!isEnabled()) return null;

  const row = { syncId: syncId || "NO_SYNC_ID", timestamp: nowIso(), event, data };
  const store = getStore();
  if (store) store.push(row);

  if (typeof console !== "undefined") {
    console.log(`%c[BEE SYNC] ${row.syncId} :: ${event}`, "color:#2563eb;font-weight:bold", data);
  }

  return row;
};